import { Typography, styled } from '@mui/material';

export const EllipsisTypography = styled(Typography)(() => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));
